import { ComponentProps } from "react";

const DownStrongArrow = ({
	shade = "#6f468e",
	...props
}: ComponentProps<"svg"> & { shade?: string }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 18.48" {...props}>
		<defs>
			<style>{`.cls-1{fill:${shade}}`}</style>
		</defs>
		<g id="Layer_2" data-name="Layer 2">
			<g id="Layer_1-2" data-name="Layer 1">
				<path style={{ fill: `${shade}` }} d="M1.56 0H6.43V7.11H1.56z" />
				<path style={{ fill: `${shade}` }} d="M4 9.24L0 6.21 8 6.21 4 9.24z" />
				<path style={{ fill: `${shade}` }} d="M9.56 0H14.43V11.73H9.56z" />
				<path style={{ fill: `${shade}` }} d="M12 13.86L8 10.83 16 10.83 12 13.86z" />
				<path style={{ fill: `${shade}` }} d="M17.56 0H22.43V16.35H17.56z" />
				<path style={{ fill: `${shade}` }} d="M20 18.48L16 15.45 24 15.45 20 18.48z" />
			</g>
		</g>
	</svg>
);

export default DownStrongArrow;
